import { render, staticRenderFns } from "./Factuur.vue?vue&type=template&id=c560ae04"
import script from "./Factuur.vue?vue&type=script&lang=js"
export * from "./Factuur.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports